import { Injectable } from "@angular/core";
// import { JobHome } from './home';
// import { JOBHOME } from '../mock-data';  //mock数据  jobHome

import { CusHttp } from "../core/services/CusHttp";

// 定义接口
// 岗位列表接口 实习就业首页岗位搜索接口

const joblist = "v1/position/search";

//合作企业高校接口
const COOPERDATA_url = "v1/public/cooperation";



@Injectable()
export class HomeService {
  constructor(public _http: CusHttp) {}

  // 岗位列表接口 实习就业首页岗位搜索接口
  getJobsList(str?: string) {
    let url = joblist + `?sort=${str ? str : ""}&num=10`;
    return this._http.get(url);
  }
  //合作企业高校接口
  // const COOPERDATA_url ='v1/public/cooperation?type='
  getCooperData(type: string) {
    let url = COOPERDATA_url + `?type=${type}`;
    return this._http.get(url);
  }


}



// WEBPACK FOOTER //
// /data/wwwroot/xzhipin/app-client/src/app/home/home.service.ts